import { DateTime } from 'luxon';
import { capitalize } from 'vue';

import i18n from '@/vueI18n';

import { Option } from '..';

export default class AdvancedReportOptions {
  static getLocalizedOptionName(name) {
    return capitalize(i18n.global.t(`options.advancedReport.${name}`));
  }

  static reportTypeOptions() {
    return [
      Option.fromObject({
        value: 'CAPPED_IMPRESSIONS',
        name: AdvancedReportOptions.getLocalizedOptionName('reportType.cappedImpressions'),
      }),
      Option.fromObject({
        value: 'CONTENDING_LINEITEMS',
        name: AdvancedReportOptions.getLocalizedOptionName('reportType.contendingLineitems'),
      }),
      Option.fromObject({
        value: 'NAUTILUS',
        name: AdvancedReportOptions.getLocalizedOptionName('reportType.nautilus'),
      }),
      Option.fromObject({
        value: 'ALLVISION_BILLING',
        name: AdvancedReportOptions.getLocalizedOptionName('reportType.allVision'),
      }),
      Option.fromObject({
        value: 'FILL_RATE',
        name: AdvancedReportOptions.getLocalizedOptionName('reportType.fillRate'),
      }),
      Option.fromObject({
        value: 'ACTIVE_AGENT_REPORT',
        name: AdvancedReportOptions.getLocalizedOptionName('reportType.activeAgentReport'),
      }),
    ];
  }

  static reportForYearOptions() {
    const yearToStart = 2018;
    const currentYear = DateTime.local().toFormat('yyyy');
    const options = [];
    for (let i = yearToStart; i <= currentYear; i += 1) {
      options.push(i);
    }
    return options;
  }
}
